import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-settings-button',
    templateUrl: './settings-button.component.html',
    styleUrls: ['./settings-button.component.scss'],
})
export class SettingsButtonComponent implements OnInit {
    @Input()
    cssClass = 'settings-fab-button-icon-dark';
    constructor() { }

    ngOnInit() {}

}
